import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAccessKey } from "./baseQuery";

export const connectionsApi = createApi({
  reducerPath: "connectionsApi",
  baseQuery: baseQueryWithAccessKey,
  tagTypes: ["connections-list"],
  endpoints: (builder) => ({
    getConnections: builder.query({
      query: (params) => ({
        url: "/api/glabp/",
        params: { page: "Connexions_All", ...params },
      }),
    }),
  }),
});

export const { useGetConnectionsQuery } = connectionsApi;
